/**
 * The one error type the UI sees from the data layer. `message` is always
 * safe to show; backend detail stays out of it and is never logged, since
 * responses may carry customer data (§41).
 */
export class ApiError extends Error {
  readonly kind: 'network' | 'not_found' | 'unavailable';

  constructor(kind: ApiError['kind'], message: string) {
    super(message);
    this.name = 'ApiError';
    this.kind = kind;
  }
}

export function toApiError(error: unknown): ApiError {
  if (error instanceof ApiError) return error;
  const offline = typeof navigator !== 'undefined' && !navigator.onLine;
  return offline
    ? new ApiError('network', 'You appear to be offline. Check your connection and try again.')
    : new ApiError('unavailable', 'We could not load this right now. Please try again.');
}
